import { render, staticRenderFns } from "./shippingOrderList.vue?vue&type=template&id=969d46a8&scoped=true&"
import script from "./shippingOrderList.vue?vue&type=script&lang=js&"
export * from "./shippingOrderList.vue?vue&type=script&lang=js&"
import style0 from "./shippingOrderList.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./shippingOrderList.vue?vue&type=style&index=1&id=969d46a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "969d46a8",
  null
  
)

component.options.__file = "shippingOrderList.vue"
export default component.exports